<template>
  <div>
    <cominca-loader :progress="loader.progress" :is-loaded="loader.isLoaded" />

    <section class="l-index" 
      ref="index"
      :class="{
         'is-loaded': loader.isLoaded
      }"
      @transitionend="onTransitionend">
      <div class="p-indexEyecatch" :style="{
        height: eyecatchHeight
      }">
        <div>
          <img src="../assets/img/logo/logo_white.svg" alt="SETOUCHI COMINCA STAYS" class="p-indexEyecatch__logo">
          <h2 class="p-indexEyecatch__heading">{{ info.top_key_title }}</h2>
          <p class="p-indexEyecatch__caption">{{ info.top_key_description }}</p>
        </div>
        <cominca-slider 
          :images="images" 
          class="p-indexEyecatch__slider" 
          ref="slider" />
        <span class="p-indexEyecatch__scroll" :class="{
          'is-hidden': isScrollHidden
        }">Scroll</span>
      </div>
    
      <section class="p-introduction">
        <scroll-animation-unit 
          class="p-introduction__content">
          <h3 class="p-introduction__heading u-fade">{{ info.top_concept_title }}</h3>
          <div class="p-introduction__text">
            <p class="u-fade" v-html="info.top_concept_description"></p>
          </div>
          <div class="p-buttonContainer p-introduction__button u-fade">
            <transition-button to="about">About Setouchi Cominca Stays</transition-button>  
          </div>
        </scroll-animation-unit>
        
        <!-- 花と家の画像 -->
        <scroll-animation-unit class="p-introduction__illustration js-rellax" data-name="flower-1" data-rellax-speed="-0.8">
          <img src="../assets/img/top/sakura01@2x.png" alt="">
        </scroll-animation-unit>
        <scroll-animation-unit class="p-introduction__illustration js-rellax" data-name="cominca" data-rellax-speed="-1.4">
          <img src="../assets/img/top/cominca@2x.png" alt="">
        </scroll-animation-unit>
        <scroll-animation-unit class="p-introduction__illustration js-rellax" data-name="flower-2" data-rellax-speed="-1">
          <img src="../assets/img/top/sakura02@2x.png" alt="">
        </scroll-animation-unit>
        <!-- /花と家の画像 -->
      </section>
    
      <section class="l-index__destination">
        <scroll-animation-unit>
          <h3 class="c-heading u-fade" data-bold>Destination</h3>
        </scroll-animation-unit>
        <scroll-spy ref="scrollSpy">
          <scroll-spy-section 
            v-for="destination in posts" 
            :key="destination.acf.dest_name"
            :label="destination.acf.dest_name">
            <destination-section :destination="destination" />
          </scroll-spy-section>
        </scroll-spy>
      </section>
    
      <page-navigation 
        :sections="sections" 
        :class="{
          'is-brighten': isNavigationBrighten
        }" />
    </section>
  </div>
</template>

<script>
  /**
   * Modules
   */
  import Rellax from 'rellax'
  import imagesLoaded from 'imagesloaded'

  import { mapGetters, mapActions, mapMutations } from 'vuex'
  
  import ComincaLoader from '~/partial/cominca-loader'
  import ComincaSlider from '~/partial/cominca-slider'
  import DestinationSection from '~/partial/destination-section'
  import PageNavigation from '~/partial/page-navigation'
  import TransitionButton from '~/partial/transition-button'

  import navigationSwitch from '~/mixins/navigation-switch'
  import objectFitCover from '~/mixins/object-fit-cover'

  import store from '~/store'

  // import posts from '~/data/destination/posts.json'

  /**
   * Share Partial
   */

  export default {
    name: 'page-top',
    mixins: [navigationSwitch, objectFitCover],
    components: {
      ComincaLoader,
      ComincaSlider,
      DestinationSection,
      PageNavigation,
      TransitionButton,
    },
    data() {
      return {
        type: '',
        posts: {},
        model: {
          title: ''
        },
        info: {},
        loader: {
          progress: 0,
          isLoaded: false
        },
        rellax: null,
        images: [],
        sections: [],
        isScrollHidden: false,
      }
    },
    computed: {
      isMobile() {
        return this.$window.viewport === 'mobile'
      },
      eyecatchHeight() {
        return this.isMobile ? `${this.$window.height}px` : '100vh'
      },
      ...mapGetters({
        'getPosts': 'posts/getPosts',
        'getInfo': 'route/getInfo',
      }),
    },
    watch: {
      isMobile(value) {
        // SP でparallax無効
        this.destroyParallax()

        if(!value) {
          this.$nextTick(() => {
            this.initializeParallax()  
          })  
        }
      },
      '$window.scrollY'(value) {
        if(value > global.innerHeight / 5) {
          this.isScrollHidden = true
        }
      }
    },
    beforeRouteEnter(to, from, next) {
      if(from.path !== '/') {
        store.commit('loader/HIDE')
      }

      next()
    },
    beforeRouteLeave(to, from, next) {
      this.showLoader()
      next()
    },
    created() {
      this.routing(this.getInfo());
    },
    mounted() {
      this.loadImages()

      // console.log(this.posts);
      // console.log(this.getInfo());
      // console.log(this.getPosts('accommodation'))

      this.info = this.getInfo().top_info
      this.images = this.info.top_key_visual
    },
    beforeDestroy() {
      this.destroyParallax()
    },
    methods: {
      routing(status={}) {
        this.type = 'top';
        this.model.title = 'TOP';
        this.posts = this.getPosts('destination');
      },
      loadImages() {
        let loader = imagesLoaded(this.$el)

        loader.on('progress', (instance, image) => {
          this.loader.progress = instance.progressedCount / instance.images.length

          if(this.loader.progress >= 1) {
            this.loader.isLoaded = true

            this.$refs.slider.start()

            this.$refs.scrollSpy.watch()
            this.sections = this.$refs.scrollSpy.getLabels()

            this.$_navigationSwitch_setTriggers('.js-navigation-switch')

            

            if(!this.isMobile) {
              this.initializeParallax()
            }
          }
        })
      },
      initializeParallax() {
        // eslint-disable-next-line no-new
        this.rellax = new Rellax('.js-rellax', {
          center: true,
        })
      },
      destroyParallax() {
        this.rellax && this.rellax.destroy()
      },
      onTransitionend() {
        this.$nextTick(() => {
          this.$refs.index.style.filter = 'none'
          this.$refs.index.style.willChange = 'auto'
        })
      },
      ...mapMutations({
        'showLoader': 'loader/SHOW',
        'hideLoader': 'loader/HIDE',
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/top.vue